import React from "react";
import { Outlet } from "react-router";
import type { MeUserDataType } from "src/app";
import { EMBEDDED_CHAT_WIDTH } from "src/common/layout-constants";
import { useEmbeddedChatBreakpoint } from "src/components/embedded-chat";
import { EvaluationBanner } from "src/components/EvaluationBanner";
import { Header } from "src/components/header";
import { LeftNavigation } from "src/components/left-navigation";
import { Toaster } from "src/components/ui/toaster";
import { useEmbeddedChat } from "src/context/EmbeddedChatContext";
import { NavigationProvider, useNavigation } from "src/context/NavigationContext";


export function DagvestigationsPage() {
  return (
    <div className="w-full h-full">
      <Outlet />
    </div>
  );
}

function DagvestigationsPageLayoutContent({ page, me }: { page: React.ReactElement, me: MeUserDataType }) {
  const { isLeftNavCollapsed } = useNavigation();
  const { isOpen: isEmbeddedChatOpen, isDisabled: isEmbeddedChatDisabled } = useEmbeddedChat();
  const breakpoint = useEmbeddedChatBreakpoint();
  const shouldApplyMargin = isEmbeddedChatOpen && !isEmbeddedChatDisabled && breakpoint === "desktop";

  return (
    <div className="h-screen flex bg-background overflow-hidden">
      <LeftNavigation isCollapsed={isLeftNavCollapsed} />
      <div
        className="flex flex-col flex-1 min-w-0 h-screen transition-[margin-right] duration-300 ease-in-out"
        style={{ marginRight: shouldApplyMargin ? EMBEDDED_CHAT_WIDTH : 0 }}
      >
        <Header me={me} />
        <EvaluationBanner suspendedAt={me.organization?.suspendedAt ?? null} />
        <main className="flex-1 flex flex-col h-full relative max-h-full overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br dark:from-slate-900/5 dark:to-slate-950/10 pointer-events-none"></div>
          {page}
        </main>
      </div>
      <Toaster />
    </div>
  );
}

// Apply the new layout with left navigation
DagvestigationsPage.getLayout = (page: React.ReactElement, me: MeUserDataType) => {
  return (
    <NavigationProvider>
      <DagvestigationsPageLayoutContent page={page} me={me} />
    </NavigationProvider>
  );
};

export default DagvestigationsPage;